import React from 'react';
import { useMarketplaceHeaderBi } from '../../../hooks/useMarketplaceHeaderBi';
import { MarketplaceLogo } from '../../../images';
import { LOGO_HEIGHT, LOGO_WIDTH } from '../../../utils/constants';

const FormattedMarketplaceLogo = ({
  isInternal,
  marketplaceUrlPrefix,
  pageName,
}: {
  isInternal: boolean;
  marketplaceUrlPrefix: string;
  pageName: string;
}) => {
  const biReport = useMarketplaceHeaderBi(pageName);

  return (
    <li className={`cell ${isInternal ? 'internal' : ''}`}>
      <a
        href={`${marketplaceUrlPrefix}`}
        data-hook="logo-link"
        onClick={() => {
          biReport({
            clickType: 'wix marketplace',
          });
        }}
        style={{ height: `25px` }}
      >
        <MarketplaceLogo width={LOGO_WIDTH} height={LOGO_HEIGHT} />
      </a>
      {isInternal && (
        <div>
          <h5 className="internal">&nbsp;/ INTERNAL</h5>
          <h5 className="internal">&nbsp;/ ENRICH</h5>
        </div>
      )}
    </li>
  );
};

export default FormattedMarketplaceLogo;
